import React, { useState } from 'react'
import styles from './Index.module.css';
import { RxDashboard } from "react-icons/rx";
import { IoIosSettings, IoIosLogOut } from "react-icons/io";
import { FaRegCircleUser } from "react-icons/fa6";
import { Card, Table } from "reactstrap";
import { FaAngleUp, FaAngleDown, FaUserPlus } from "react-icons/fa";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { GoHomeFill } from "react-icons/go";
import NavBar from './NavBar';
import { CiCircleMinus, CiCirclePlus } from 'react-icons/ci';
import { MdAssignmentInd } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiFillDelete } from "react-icons/ai";
import WarningMessage from '../../common/warnMsg';
import httpService from '../../../services/http.service';
import SuccessMessage from '../../common/successMsg';
import ErrorMessage from '../../common/errorMsg';
import { useHistory } from 'react-router-dom';
import Loader from './Loader';




const UserInformation = ({ allData, isLoading, isPropertyOpen, setIsPropertyOpen, setRefresh }) => {
    const [openDialog, setOpenDialog] = useState({
        name: '',
        type: '',
        id: ''
    })

    const [loading, setLoading] = useState(false)
    const history = useHistory()

    const [formData, setFormData] = useState({
        username: "",
        userEmail: "",
        phone: "",
    });

    const [propertyFormData, setPropertyFormData] = useState({
        Name: "",
        Address1: "",
        Address2: "",
        Country: "",
        State: "",
        City: "",
        Zip: "",
        PhoneNumber: "",
        Email: "",
        ContactName: "",
        UserId: ""
    })

  
    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailRegex.test(email);
    }

    const [quantity, setQuantity] = useState(1)
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);


    const handleOnChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }
    const handleCheck = (id) => {
        setSelectedUsers((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };



    const handlePropertyOnChange = (e) => {
        const { name, value } = e.target
        setPropertyFormData({
            ...propertyFormData,
            [name]: value
        })
    }

    const handleCreateUser = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            if (!formData.username) {
                WarningMessage("Please enter the Account Name");
                return;
            }

            if (!formData.userEmail) {
                WarningMessage("Please Enter the email address");
                return;
            }

            if (!formData.phone) {
                WarningMessage("Please enter the phone number");
                return;
            }

            const dataObj = {
                customerId: formData.username,
                email: formData.userEmail,
                mobileNo: formData.phone,
                licenceNo: quantity
            }

            const { data } = await httpService.CreateUpdate("property-manager/user", dataObj)

          

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            if (data.ack === "1") {
                SuccessMessage(data.message)
            }

            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })
            setFormData({
                username: "",
                userEmail: "",
                phone: "",
            })
            setRefresh(prev => prev + 1)

        } catch (error) {
            ErrorMessage("Something went wrong")
        }
        finally {
            setLoading(false)
        }
    }

    const handleCreateProperty = async (e) => {
        e.preventDefault()
        try {

            const dataObj = {
                Name: propertyFormData.Name,
                Address1: propertyFormData.Address1,
                Address2: propertyFormData.Address2,
                Country: propertyFormData.Country,
                State: propertyFormData.State,
                City: propertyFormData.City,
                Zip: propertyFormData.Zip,
                PhoneNumber: propertyFormData.PhoneNumber,
                Email: propertyFormData.Email,
                ContactName: propertyFormData.ContactName,
                UserId: openDialog.id
            }

            const { data } = await httpService.CreateUpdate("property-manager/add-property", dataObj)

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            if (data.ack === "1") {
                SuccessMessage(data.message)
            }
            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })
            setPropertyFormData({
                Name: "",
                Address1: "",
                Address2: "",
                Country: "",
                State: "",
                City: "",
                Zip: "",
                PhoneNumber: "",
                Email: "",
                ContactName: "",
                UserId: ""
            })
            setRefresh(prev => prev + 1)
        } catch (error) {
            ErrorMessage("Something went wrong")
        }
    }

    const handleDeleteProperty = async () => {
        try {
            const { data } = await httpService.CreateUpdate("property-manager/delete-property", { propertyId: openDialog.id })

            if (data.ack === "1") {
                SuccessMessage(data.message)
            }
            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })
            setPropertyFormData({
                Name: "",
                Address1: "",
                Address2: "",
                Country: "",
                State: "",
                City: "",
                Zip: "",
                PhoneNumber: "",
                Email: "",
                ContactName: "",
                UserId: ""
            })
            setRefresh(prev => prev + 1)
        } catch (error) {
            WarningMessage("Something went wrong")
        }
    }

    const handleAssignUserToProperty = async () => {
        try {
            if (selectedUsers.length <= 0) {
                return WarningMessage("Select the user first")
            }

            const dataObj = {
                propertyId: openDialog.id,
                userIdArray: selectedUsers
            }

            const { data } = await httpService.CreateUpdate("/property-manager/assign-user", dataObj)

           

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            if (data.ack === "1") {
                SuccessMessage(data.message)
            }

            setSelectedUsers([])
            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })

            setRefresh(prev => prev + 1)

        } catch (error) {
            WarningMessage("Something went wrong")
        }
    };

    const handleUnassignUser = async () => {
        try {

            const dataObj = {
                propertyId: isPropertyOpen,
                userId: openDialog.id
            }

            const { data } = await httpService.CreateUpdate("property-manager/unassign-user", dataObj)

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            if (data.ack === "1") {
                SuccessMessage(data.message)
            }

            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })
            setRefresh(prev => prev + 1)

        } catch (error) {
            console.log(error)
            if (error.response.status === 401) {
                history.push("/")
                ErrorMessage(error.response.data.message)
                localStorage.clear()
            }
        }
    }

    const handleUpdateProperty = async (e) => {
        e.preventDefault()
        try {

            const dataObj = {
                Name: propertyFormData.Name,
                Address1: propertyFormData.Address1,
                Address2: propertyFormData.Address2,
                Country: propertyFormData.Country,
                State: propertyFormData.State,
                City: propertyFormData.City,
                Zip: propertyFormData.Zip,
                PhoneNumber: propertyFormData.PhoneNumber,
                Email: propertyFormData.Email,
                ContactName: propertyFormData.ContactName,
                propertyId: openDialog.id
            }

            const { data } = await httpService.CreateUpdate("/property-manager/update-property", dataObj)


            if (data.ack === "1") {
                SuccessMessage(data.message)
            }

            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })
            setPropertyFormData({
                Name: "",
                Address1: "",
                Address2: "",
                Country: "",
                State: "",
                City: "",
                Zip: "",
                PhoneNumber: "",
                Email: "",
                ContactName: "",
                UserId: ""
            })
            setRefresh(prev => prev + 1)

        } catch (error) {
            ErrorMessage("Something went wrong")
        }
    }

    return (
        <>
            <div className={styles.rightContainer} >
                <NavBar />
                <div style={{ flex: 1, width: "100%", padding: 10, minHeight: 0 }}>
                    <div style={{
                        height: "100%",
                        width: "100%",
                        border: "0.5px solid #D3D3D3",
                        borderRadius: 10,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        {/* Header */}
                        {isLoading ? <Loader /> : <>
                            <div style={{
                                height: 50,
                                width: "100%",
                                backgroundColor: "#F8F9FA",
                                padding: "0px 5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexShrink: 0
                            }}>
                                <div style={{ fontSize: 15, fontWeight: "bold" }}>Property Manager</div>
                                <div style={{ fontSize: 17, color: "red", fontWeight: 500, border: "2px solid red", padding: 5, borderRadius: 5 }}>{`${allData?.usedProperty}/${allData?.propertyManagerDetails?.licenceNo} Licence Used`}</div>
                                <div style={{ display: "flex", gap: 10 }}>
                                    <button style={{ border: "none", outline: "none", padding: 9, borderRadius: 10, display: "flex", alignItems: "center", gap: 5 }} onClick={() => setOpenDialog({
                                        type: "createUser",
                                        name: "Create New User"
                                    })}>
                                        <FaUserPlus size={18} />
                                        Create New User
                                    </button>
                                    {allData?.usedProperty >= allData?.propertyManagerDetails?.licenceNo ? <></> : <button style={{ border: "none", outline: "none", padding: 9, borderRadius: 10, display: "flex", alignItems: "center" }} onClick={() => setOpenDialog({
                                        name: 'Add Property',
                                        type: 'addProperty',
                                    })}>
                                        <IoMdAdd size={18} />
                                        Add Property
                                    </button>}
                                </div>
                            </div>
                            <div style={{
                                flex: 1,
                                width: "100%",
                                overflowY: "auto",
                                minHeight: 0,
                                padding: 8
                            }}>

                                {allData?.property?.length === 0 ? <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>User has not created any property.</div> : allData?.property?.map((property, index) => {
                                    return (
                                        <>
                                            <div key={property._id} style={{
                                                width: "100%", height: 50, border: "0.5px solid #D3D3D3",
                                                borderRadius: 10,
                                                marginBottom: 7,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "0px 5px"

                                            }}>
                                                {property.Name}
                                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                    <button title="Assign User" style={{ border: "none", outline: "none", padding: 9, borderRadius: 10, display: "flex", alignItems: "center", gap: 3, backgroundColor: "#5C636A", color: "white" }} onClick={() => setOpenDialog({
                                                        name: 'Assign user to Property',
                                                        type: 'assignUserToProperty',
                                                        id: property._id
                                                    })}>
                                                        <MdAssignmentInd size={19} />
                                                    </button>
                                                    <button title="Edit" style={{ border: "none", outline: "none", padding: 9, borderRadius: 10, display: "flex", alignItems: "center", gap: 3, backgroundColor: "green", color: "white" }}
                                                        onClick={() => {
                                                            setOpenDialog({
                                                                name: 'Edit Property',
                                                                type: 'editProperty',
                                                                id: property._id
                                                            })
                                                            setPropertyFormData({
                                                                Name: property.Name,
                                                                Address1: property.Address1,
                                                                Address2: property.Address2,
                                                                Country: property.Country,
                                                                State: property.State,
                                                                City: property.City,
                                                                Zip: property.Zip,
                                                                PhoneNumber: property.PhoneNumber,
                                                                Email: property.Email,
                                                                ContactName: property.ContactName,
                                                            })
                                                        }}
                                                    >
                                                        <MdEdit size={19} />
                                                    </button>
                                                    <button title="Delete" style={{ border: "none", outline: "none", padding: 9, borderRadius: 10, display: "flex", alignItems: "center", gap: 3, backgroundColor: "red", color: "white" }} onClick={() => setOpenDialog({
                                                        name: 'Delete Property',
                                                        type: 'deleteProperty',
                                                        id: property._id
                                                    })}>
                                                        <AiFillDelete size={19} />
                                                    </button>
                                                    <div style={{ height: 35, width: 35, borderRadius: "50%", backgroundColor: "#D0D0D7", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        {isPropertyOpen === property._id ? <FaAngleUp size={19} onClick={() => setIsPropertyOpen("")} /> : <FaAngleDown size={19} onClick={() => setIsPropertyOpen(property._id)} />}
                                                    </div>
                                                </div>
                                            </div>
                                            {isPropertyOpen === property._id && <div key={"property" + index}>
                                                <Card className='card-this' style={{ padding: "0 15px" }}>
                                                    <div style={{ border: "0.5px solid #D3D3D3", marginBottom: 10, backgroundColor: "transparent" }}>
                                                        <Table className="table-inner">
                                                            <thead className="bg-header" style={{ position: 'sticky', top: '0', zIndex: '5' }}>
                                                                <tr>
                                                                    <th>Account Name</th>
                                                                    <th>Account No.</th>
                                                                    <th>Email</th>
                                                                    <th>Mobile No.</th>
                                                                    <th>Unassign</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="font12"
                                                            >
                                                                {allData.users.filter((user, i) => {

                                                                    const findProperty = allData.property.find(
                                                                        (property) => property._id === isPropertyOpen
                                                                    );

                                                                    return findProperty?.UserId.includes(user._id)
                                                                }).map((user, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr
                                                                                key={index}
                                                                                className="pointer"
                                                                            >
                                                                                <td>{user.customerId}</td>
                                                                                <td>
                                                                                    {user.accountNo}
                                                                                </td>
                                                                                <td >
                                                                                    {user.email}
                                                                                </td>
                                                                                <td >
                                                                                    {user.mobileNo}
                                                                                </td>
                                                                                <td>
                                                                                    <button
                                                                                        style={{
                                                                                            transform: "scale(0.8)",
                                                                                        }}
                                                                                        className="btn btn-sm btn-danger"
                                                                                        onClick={() => {
                                                                                            setOpenDialog({
                                                                                                name: 'Unassign User',
                                                                                                type: 'unassignProperty',
                                                                                                id: user._id
                                                                                            })
                                                                                        }}
                                                                                    >
                                                                                        <i className="trash icon me-0"></i>
                                                                                    </button>{" "}
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Card>
                                            </div>}
                                        </>
                                    )
                                }
                                )}
                            </div>
                        </>}

                    </div>
                </div>
            </div>
            <Modal
                isOpen={openDialog.type === 'addProperty' || openDialog.type === 'editProperty'}
                // size="sm"
                centered={true}
            >
                <ModalHeader toggle={() => {
                    setOpenDialog({
                        name: '',
                        type: '',
                        id: ''
                    })
                    setPropertyFormData({
                        Name: "",
                        Address1: "",
                        Address2: "",
                        Country: "",
                        State: "",
                        City: "",
                        Zip: "",
                        PhoneNumber: "",
                        Email: "",
                        ContactName: "",
                        UserId: ""
                    })
                }}>{openDialog.name}</ModalHeader>
                <ModalBody>
                    <div className="ui main">
                        <form className="ui form" onSubmit={openDialog.type === "editProperty" ? handleUpdateProperty : handleCreateProperty}>
                            <div className="field">
                                <label>Name<i style={{ color: "red" }} >*</i></label>
                                <input
                                    type="text"
                                    value={propertyFormData.Name}
                                    name="Name"
                                    placeholder="Name"
                                    onChange={handlePropertyOnChange}
                                    required
                                />
                            </div>
                            <div className="field">
                                <label>Address1</label>
                                <input
                                    type="text"
                                    value={propertyFormData.Address1}
                                    name="Address1"
                                    placeholder="Address1"
                                    onChange={handlePropertyOnChange}
                                />
                            </div>
                            <div className="field">
                                <label>Address2</label>
                                <input
                                    type="text"
                                    value={propertyFormData.Address2}
                                    name="Address2"
                                    placeholder="Address2"
                                    onChange={handlePropertyOnChange}
                                />
                            </div>
                            <div className="row">
                                <div className="field col-6" style={{ paddingRight: "3px" }}>
                                    <label>Country</label>
                                    <input
                                        type="text"
                                        value={propertyFormData.Country}
                                        name="Country"
                                        placeholder="Country"
                                        onChange={(e) => {
                                            const regex = /^[A-Za-z ]*$/;
                                
                                            const { value } = e.target;
                                            if (regex.test(value)) {
                                                handlePropertyOnChange(e);
                                            }
                                        }}

                                    />
                                </div>
                                <div className="field col-6" style={{ paddingLeft: "3px" }}>
                                    <label>State</label>
                                    <input
                                        type="text"
                                        value={propertyFormData.State}
                                        name="State"
                                        placeholder="State"
                                        onChange={(e) => {
                                            const regex = /^[A-Za-z ]*$/
                                            const { value } = e.target
                                            if (regex.test(value)) {
                                                handlePropertyOnChange(e)
                                            }
                                        }}
                                    />
                                </div>
                                <div className="field col-6" style={{ paddingRight: "3px" }}>
                                    <label>City</label>
                                    <input
                                        type="text"
                                        value={propertyFormData.City}
                                        name="City"
                                        placeholder="City"
                                        onChange={(e) => {
                                            const regex = /^[A-Za-z ]*$/
                                            const { value } = e.target
                                            if (regex.test(value)) {
                                                
                                                handlePropertyOnChange(e)
                                            }
                                        }}
                                    />
                                </div>
                                <div className="field col-6" style={{ paddingLeft: "3px" }}>
                                    <label>Zip</label>
                                    <input
                                        type="text"
                                        value={propertyFormData.Zip}
                                        name="Zip"
                                        placeholder="Zip"
                                        onChange={(e) => {
                                            const regex = /^[0-9]*$/
                                            const { value } = e.target
                                            if (regex.test(value)) {
                                                handlePropertyOnChange(e)
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="field">
                                <label>Phone Number <i style={{ color: "red" }} >*</i></label>
                                <input
                                    type="text"
                                    value={propertyFormData.PhoneNumber}
                                    name="PhoneNumber"
                                    placeholder="Phone Number"
                                    maxLength="10"
                                    onChange={(e) => {
                                        const { value } = e.target
                                        const regex = /^[0-9]*$/
                                        if (regex.test(value)) {
                                            handlePropertyOnChange(e)
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <div className="field">
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={propertyFormData.Email}
                                    name="Email"
                                    placeholder="Email"
                                    onChange={handlePropertyOnChange}
                                />
                            </div>
                            <div className="field">
                                <label>Contact Name</label>
                                <input
                                    type="text"
                                    name="ContactName"
                                    value={propertyFormData.ContactName}
                                    placeholder="Contact Name"
                                    onChange={(e) => {
                                        const regex = /^[A-Za-z ]*$/
                                        const { value } = e.target
                                        if (regex.test(value)) {
                                            handlePropertyOnChange(e)
                                        }
                                    }}
                                />
                            </div>
                            <div className="text-end">
                                <Button
                                    color="success"
                                    type='submit'
                                >
                                    {openDialog.type === "editProperty" ? "Update" : "Add Property"}
                                </Button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={openDialog.type === 'createUser'}
                centered={true}
            >
                <ModalHeader toggle={() => setOpenDialog({
                    name: '',
                    type: ''
                })}>{openDialog.name}</ModalHeader>
                <ModalBody>
                    <div className="ui main">
                        <form className="ui form" onSubmit={handleCreateUser}>
                            <div className="field">
                                <label>Account Name<i style={{ color: "red" }} >*</i></label>
                                <input
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    placeholder="Account Name"
                                    onChange={(e) => {
                                        const regex = /^[a-zA-Z0-9_ ]*$/
                                        const { value } = e.target

                                        if (regex.test(value)) {
                                            handleOnChange(e)
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <div className="field">
                                <label>Email<i style={{ color: "red" }} >*</i></label>
                                <input
                                    type="email"
                                    value={formData.userEmail}
                                    name="userEmail"
                                    onChange={handleOnChange}
                                    placeholder="Email"
                                    required
                                />
                            </div>
                            <div className="field">
                                <label>Phone Number <i style={{ color: "red" }} >*</i></label>
                                <input
                                    type="text"
                                    value={formData.phone}
                                    name="phone"
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        const regex = /^[0-9]*$/

                                        if (regex.test(value)) {
                                            handleOnChange(e)
                                        }
                                    }}
                                    maxLength="10"
                                    placeholder="Phone Number"
                                    required
                                />
                            </div>
                            {/* <div className="field">
                                <label>Property <i style={{ color: "red" }} >*</i></label>
                                <div style={{ display: "flex", gap: 2 }}>
                                    <div style={{ outline: "none", border: "none", padding: "0px 20px", backgroundColor: "#F8F9FA", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={() => setQuantity((prev) => prev - 1 <= 0 ? 1 : prev - 1)}>
                                        <CiCircleMinus size={25} />
                                    </div>
                                    <input
                                        type="text"
                                        value={quantity}
                                        name="property"
                                        style={{ textAlign: "center" }}
                                        onChange={(e) => {
                                            const number = e.target.value.replace(/[^0-9]/g, '')
                                            setQuantity(number ? parseInt(number) : '');
                                        }}
                                        onBlur={(e) => {
                                            const number = e.target.value.replace(/[^0-9]/g, '')
                                            setQuantity(number ? parseInt(number) : '1');
                                        }}

                                        readOnly

                                    />
                                    <div disabled={quantity < 0 ? true : false} style={{ outline: "none", border: "none", padding: "0px 20px", backgroundColor: "#F8F9FA", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={() => setQuantity((prev) => prev + 1)}><CiCirclePlus size={25} /></div>
                                </div>

                            </div> */}
                            <div className="text-end">
                                <Button
                                    type='submit'
                                    color="success"
                                >
                                    Create User
                                </Button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={openDialog.type === "assignUserToProperty"} centered >
                <ModalHeader toggle={() => {
                    setOpenDialog({
                        name: '',
                        type: '',
                        id: ''
                    })
                    setSelectedUsers([])
                }} >
                    <strong>Select Users</strong>
                </ModalHeader>

                <ModalBody>
                    {/* Scrollable List */}
                    <div
                        style={{
                            maxHeight: "250px",
                            overflowY: "auto",
                            paddingRight: "4px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            background: "#fafafa",
                        }}
                    >

                        {(() => {
                            const filteredUsers = allData.users
                                ?.filter((user) => {
                                    const findProperty = allData.property.find(
                                        (property) => property._id === openDialog.id
                                    );

                                    return !findProperty?.UserId.includes(user._id);
                                }) || [];

                            // If no users available
                            if (filteredUsers.length === 0) {
                                return (
                                    <p style={{ padding: "10px", textAlign: "center", color: "#888" }}>
                                        No users found
                                    </p>
                                );
                            }

                            // Show users list
                            return filteredUsers.map((user) => (
                                <label
                                    key={user._id}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px 12px",
                                        borderBottom: "1px solid #eee",
                                        cursor: "pointer",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedUsers.includes(user._id)}
                                        onChange={() => handleCheck(user._id)}
                                        style={{
                                            marginRight: "10px",
                                            width: "18px",
                                            height: "18px",
                                            cursor: "pointer",
                                        }}
                                    />

                                    <span style={{ fontSize: "15px", fontWeight: "500" }}>
                                        {user.customerId}
                                    </span>
                                </label>
                            ));
                        })()}


                    </div>

                    {/* Buttons */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "20px",
                        }}
                    >
                        <Button color="secondary" onClick={() => {
                            setOpenDialog({
                                name: '',
                                type: '',
                                id: ''
                            })
                            setSelectedUsers([])
                        }} >
                            Cancel
                        </Button>
                        <Button color="success" onClick={() => handleAssignUserToProperty()}>
                            Save
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={openDialog.type === "deleteProperty" || openDialog.type === "unassignProperty"} centered>
                <ModalHeader toggle={() => setOpenDialog({
                    name: '',
                    type: '',
                    id: ''
                })}>{openDialog.type === "unassignProperty" ? "Confirm Unassign" : "Confirm Delete"}</ModalHeader>

                <ModalBody>
                    {openDialog.type === "unassignProperty" ? <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                        Are you sure you want to unassign this user ?
                    </p> : <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                        Are you sure you want to delete this Property?
                        You won't be able to revert this!.
                    </p>}



                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <Button color="secondary" onClick={() => setOpenDialog({
                            name: '',
                            type: '',
                            id: ''
                        })}>
                            Cancel
                        </Button>

                        <Button color="danger" onClick={() => openDialog.type === "unassignProperty" ? handleUnassignUser() : handleDeleteProperty()}>
                            {openDialog.type === "unassignProperty" ? "Unassign" : "Delete"}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

        </>
    )
}

export default UserInformation